import React from 'react';
import { Box, Skeleton } from '@mui/material';
import HorizontalDivider from './HorizontalDivider';

function DashboardSkeleton() {
    
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingBottom: '5rem',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
      <Box
        sx={{
          display: 'flex',
          width: '920px',
          marginTop: 'calc(3rem + 70px)',
          height: '100%',
          flexDirection: 'column',
          gap: '1.5rem'
        }}>
        {/* Boxes superiores*/}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection:'column' }}>
          <Box sx={{display:'flex', flexDirection:'row', gap:'1rem'}}>
            <Skeleton variant="text" width={650} height={150} animation="wave" />
            <Skeleton variant="text" width={250} height={150} animation="wave" />
          </Box>
          
          <Skeleton sx={{marginTop:'-2rem'}} variant="text" width={920} height={200} animation="wave"  />
        </Box>
        <HorizontalDivider/>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop:'2rem' }}>
          {/* Segunda Box solicitudes */}
          <Skeleton
            animation="wave"
            variant="rectangular"
            width="100%"
            height={150}
            sx={{
              borderRadius: '1rem'
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default DashboardSkeleton;
